import React, { useContext, useEffect, useState } from "react";

import Schedule, { ScheduleContext } from "./store/Schedule";

const SchedulerProvider: React.FC = ({ children }) => {
  const [schedule] = useState(new Schedule());
  useEffect(() => {
    schedule.load();
  }, []);
  return (
    <ScheduleContext.Provider value={schedule}>
      {children}
    </ScheduleContext.Provider>
  );
};

export const useSchedule = (): Schedule => {
  const context = useContext(ScheduleContext);

  if (!context)
    throw new Error("useSchedule must be used inside SchedulerProvider");

  return context;
};

export default SchedulerProvider;
